<template>
  <div class="lxm-dashboard-news-item is-clearfix">
    <div class="lxm-dashboard-news-item__title">
      <template v-if="data.type === 'cf'">
        <span class="lxm-dashboard-news-item__type">【筹款】</span>{{ title }}
      </template>
      <template v-else-if="data.type === 'form'">
        <span class="lxm-dashboard-news-item__type">【表单】</span>
        <img v-if="data.enablePrivateForm" class="lxm-item__lock" src="../../../images/main/lock.png">{{ title }}
      </template>
      <template v-else-if="data.type === 'activity_signup' || data.type === 'activity_signin'">
        <span class="lxm-dashboard-news-item__type">【活动】</span>{{ title }}
      </template>
      <template v-else>
        {{ title }}
      </template>
    </div>
    <div class="lxm-dashboard-news-item__content">
      <template v-if="data.type === 'cf'">
         有
         <span class="lxm-dashboard-news-item__number">{{ data.num }}</span>
         笔收款，共计
         <span class="lxm-dashboard-news-item__number">{{ data.money }}</span>
         元
      </template>
      <template v-if="data.type === 'form'">
        有
        <span class="lxm-dashboard-news-item__number">{{ data.num }}</span>
        个表单提交
      </template>
      <template v-if="data.type === 'activity_signup'">
        有
        <span class="lxm-dashboard-news-item__number">{{ data.num }}</span>
        个报名提交
      </template>
      <template v-if="data.type === 'activity_signin'">
        有
        <span class="lxm-dashboard-news-item__number">{{ data.num }}</span>
        次活动签到
      </template>
    </div>
    <div class="lxm-dashboard-news-item__date-time is-pulled-left">{{ dateTime }}</div>
    <div class="lxm-dashboard-news-item__detail is-pulled-right" @click="viewClicked">
      <img class="lxm-dashboard-news-item__view" src="../../../images/main/view.png">
      查看详情
    </div>
    <div class="lxm-dashboard-news-item__vertical-line"></div>
    <div class="lxm-dashboard-news-item__circle" :style="circleStyle"></div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  .lxm-dashboard-news-item
    position: relative
    padding-bottom: spacing
    border-bottom: 1px solid white-line
    margin-left: spacing
    margin-right: spacing
    margin-bottom: spacing
    &:last-child
       margin-bottom: 0
       .lxm-dashboard-news-item__vertical-line
         height: 100%
  .lxm-dashboard-news-item__title
    margin-bottom: spacing-small
    font-size: size-big
    color: grey-darker
  .lxm-dashboard-news-item__type
    color: grey-dark
  .lxm-dashboard-news-item__content
    margin-bottom: spacing
    font-size: size-small
    color: grey-dark
  .lxm-dashboard-news-item__number
    font-size: size-big
    color: brand-primary
  .lxm-dashboard-news-item__date-time
    font-size: size-smaller
    color: grey
  .lxm-dashboard-news-item__detail
    font-size: size-smaller
    color: brand-primary
    line-height: 1
  .lxm-dashboard-news-item__view
    width: siz(12.5)
    vertical-align: top
  .lxm-dashboard-news-item__vertical-line
    position: absolute
    width: siz(1)
    height: siz(112)
    background: white-line
    top: 0
    left: siz(-8)
  .lxm-dashboard-news-item__circle
    position: absolute
    width: siz(9)
    height: siz(9)
    border: siz(2) solid passion-orange
    border-radius: 50%
    top: siz(5)
    left: siz(-12)
  .lxm-item__lock
    height: 14px
    margin-right: 4px
    margin-bottom: -2px
</style>

<script>
  import * as mTypes from '../../../../store/mutation-types'
  export default {
    props: {
      title: String,
      data: Object,
      dateTime: String
    },
    computed: {
      circleStyle () {
        switch (this.data.type) {
          case 'form':
            return {
              borderColor: '#ffb258'
            }
          case 'cf':
            return {
              borderColor: '#ff6743'
            }
          case 'activity_signup':
          case 'activity_signin':
            return {
              borderColor: '#4f86c5'
            }
          default:
            return {
              borderColor: '#999999'
            }
        }
      }
    },
    methods: {
      viewClicked () {
        if (this.data.type === 'cf') {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push({
            path: '/main/cf/project/feedback',
            query: {
              projectId: this.data.id
            }
          })
        } else if (this.data.type === 'form') {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push({
            path: '/main/form/feedback',
            query: {
              formId: this.data.id
            }
          })
        } else if (this.data.type === 'activity_signup' || this.data.type === 'activity_signin') {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push({
            path: '/main/activity/feedback',
            query: {
              activityId: this.data.id
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NewsItem.vue?004c7fa4